export function replaceCategories(object, key, replaceVal) {
  Object.keys(object).some(function (k) {
    if (k === key) {
      object[k] = replaceVal;
    }
    if (object[k] && typeof object[k] === "object") {
      object[k] = replaceCategories(object[k], key, replaceVal);
    }
  });
  return object;
}
